"use client";
import { ReactNode } from "react";
import { Provider } from "react-redux";
import { makeStore } from "./index";

const store = makeStore();
const StoreProvider = ({ children }: { children: ReactNode }) => (
  <Provider store={store}>{children}</Provider>
);

export default StoreProvider;
